import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { vehiclesHelperFailed, vehiclesHelperSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* vehiclesHelper(action) {
  try {
    let pool = {
      limit: 10,
      page: 1,
    };

    let filter = {};
    if (typeof action.payload === 'string') {
      filter.number = action.payload;
    }
    if (Array.isArray(action.payload)) {
      filter.numbers = action.payload;
    }
    if (typeof action.payload === 'object') {
      filter = action.payload;
    }
    pool = addFilterQueryWithCondition(filter, pool);
    const url = `${BACKEND_URL}/registries/vehicles`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(vehiclesHelperSuccessful(data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(vehiclesHelperFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(vehiclesHelperFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
